<template lang="">
     <div class="good-item" >
        <img :src="goodItem.img" alt="">
        <div class="goods-detail">
            <div class="good-title">
                {{goodItem.name}}
            </div>
            <div class="good-price">
                <span class="price1">¥ {{goodItem.price2}}</span>
                <span class="price2">原价:￥{{goodItem.price1}}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['goodItem']
}
</script>
<style lang="scss" scoped>
    .good-item{
                        width: 342px;
                        background: #fff;
                        margin-bottom: 20px;
                        border-radius:10px;
                        overflow: hidden;
                        img{
                            width: 100%;
                            height: 346px;
                            display: block;
                        }
                        .goods-detail{
                            padding: 24px 13px 28px 13px;
                        }
                        .good-title{
                            font-size:28px;
                            font-family:PingFang SC;
                            font-weight:500;
                            color:rgba(54,54,53,1);
                            line-height:40px;
                        }
                        .good-price{
                            font-family:PingFang SC;
                            font-weight:500;
                            margin-top: 31px;
                            .price1{
                                font-size:32px;
                                color:rgba(227,57,60,1);
                                margin-right: 14px;
                            }
                            .price2{
                                font-size:22px;
                                text-decoration:line-through;
                                color:rgba(102,102,102,1);
                            }
                        }
                        
                    }
</style>